import React from "react";

import { SxProps } from "@mui/material";
import { useSelector } from "react-redux";

import { getModal } from "src/selectors";
import { useContent } from "src/hooks";

export const useOffline = () => {
  const content = useContent();

  const modal = useSelector(getModal);

  const getModalProps = React.useCallback(
    () => ({
      open: modal.offline,
      sx: { backdropFilter: "blur(5px)" } as SxProps,
    }),
    [modal.offline]
  );

  const values = React.useMemo(
    () => ({
      content,
    }),
    [content]
  );

  return { getModalProps, values };
};
